import StepsManager from "../../components/shared/steps/StepsManager";

export default class Configurator {

    /**
     * Global instance of this class.
     * @var {Configurator}
     */
    static instance = null

    /** @var {StepsManager} */
    stepsManager = null

    /**
     * Constructs a new {@link Configurator}.
     */
    constructor(editor) {
        if (Configurator.instance) {
            throw new Error('Creating multiple Configurator instances is not allowed.')
        }

        Configurator.instance = this

        this.stepsManager = new StepsManager()
        this.editor = editor
    }

    /**
     * @public
     * @return {StepsManager}
     */
    getStepsManager() {
        return this.stepsManager
    }

    getEditor() {
        return this.editor
    }

    /**
     * Returns global instance of this class.
     * Will return null if {@link Editor} component hasn't been loaded, yet.
     *
     * @public
     * @return {Configurator|null}
     */
    static getInstance() {
        return Configurator.instance
    }
}